import { LocalStorageKeys } from 'src/types/common';

export const getSeenNotifications = (): number[] => {
  const seen = localStorage.getItem(LocalStorageKeys.SeenNotifications);

  return seen ? JSON.parse(seen) : [];
};

export const saveSeenNotification = (pk: number) => {
  const seen = getSeenNotifications().filter((id) => id !== pk);
  seen.push(pk);

  localStorage.setItem(
    LocalStorageKeys.SeenNotifications,
    JSON.stringify(seen)
  );
};
